import { useUpdateUserModal } from "./UpdateUserModal.hook";
import Modal from "../../common/components/Modal";
import { UserType } from "global";
import { lazy, Suspense } from "react";
import Loader from "../../common/components/Loader";
import SelectBox from "../../common/components/SelectBox";

interface UpdateUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  type?: UserType | null;
  userId?: string;
}

export interface FormProps {
  onClose: () => void;
  userId?: string;
}

const LAZY_FORMS: {
  [key in UserType]: React.LazyExoticComponent<React.ComponentType<FormProps>>;
} = {
  caregivers: lazy(() => import("./CaregiverForm")),
  guardians: lazy(() => import("./GuardianForm")),
  receivers: lazy(() => import("./ReceiverForm")),
};

export default function UpdateUserModal({
  onClose,
  isOpen,
  type = null,
  userId,
}: UpdateUserModalProps) {
  const {
    models: { userType, modalTitle },
    operations: { onToggleType },
  } = useUpdateUserModal(type, userId);

  const LazyFormElement = userType ? LAZY_FORMS[userType] : null;

  return (
    <Modal open={isOpen} onClose={onClose} title={modalTitle} height="900px">
      <div className="flex h-full flex-col gap-5 overflow-hidden">
        <SelectBox
          label="종류"
          value={userType!}
          onSelect={(value) => onToggleType(value)}
          options={[
            { label: "보호사", value: "caregivers" },
            { label: "보호자", value: "guardians" },
            { label: "수급자", value: "receivers" },
          ]}
        />
        <div className="flex h-full flex-col overflow-y-auto rounded-md border border-zinc-200 p-3">
          <Suspense fallback={<Loader />}>
            {LazyFormElement ? (
              <LazyFormElement onClose={onClose} userId={userId} />
            ) : (
              <></>
            )}
          </Suspense>
        </div>
      </div>
    </Modal>
  );
}
